var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Overlay from "../../layouts/Overlay/Overlay";
import { CardBodyInnerWrapper } from "./CardBody.style";
import { AccountType } from "../../../helpers/getAccountType";
import i18n from "../../../strings/i18n";
import CardBodySection from "./CardBodySection/CardBodySection";
var CardBody = function (_a) {
    var bodyData = _a.bodyData;
    var formattedPaymentDate = bodyData.data.paymentDate.split(",")[0] ||
        i18n({ labels: "unavailable" });
    // remove year
    var modifiedBodyData = __assign(__assign({}, bodyData), { data: __assign(__assign({}, bodyData.data), { paymentDate: bodyData.data.accountType === AccountType.SECURED_INSTALLMENT_LOAN
                ? bodyData.data.paymentDate
                : formattedPaymentDate }) });
    if (bodyData.isOverlay)
        return (_jsx(CardBodyInnerWrapper, { children: _jsx(Overlay, { imageSrc: bodyData.data.cardArtURL, imageAlt: bodyData.altText, overlayHeading: i18n({ labels: "overlayHeading" }), overlayText: i18n({ labels: "overlayText" }), overlayLink: "(800) 542-5593", overlayNumber: "+18005425593" }) }));
    if (bodyData.isLoanPaidOff)
        return (_jsx(CardBodyInnerWrapper, { children: _jsx(Overlay, { imageSrc: bodyData.data.cardArtURL, imageAlt: bodyData.altText, overlayHeading: i18n({ labels: "loanPaidOffOverlayHeading" }), overlayText: i18n({ labels: "loanPaidOffOverlayText" }) }) }));
    return (_jsx(CardBodySection, { accountType: bodyData.data.accountType, bodyData: modifiedBodyData }));
};
export default CardBody;
//# sourceMappingURL=CardBody.js.map